import {FC, useState, createContext, useContext} from 'react'
import {WithChildren} from '../../../../_metronic/helpers'

type ColumnVisibilityContextProps = {
  hideDatesColumn: boolean
  setHideDatesColumn: (hide: boolean) => void
}

const ColumnVisibilityContext = createContext<ColumnVisibilityContextProps>({
  hideDatesColumn: false,
  setHideDatesColumn: () => {},
})

const ColumnVisibilityProvider: FC<WithChildren> = ({children}) => {
  const [hideDatesColumn, setHideDatesColumn] = useState<boolean>(false)

  return (
    <ColumnVisibilityContext.Provider value={{hideDatesColumn, setHideDatesColumn}}>
      {children}
    </ColumnVisibilityContext.Provider>
  )
}

const useColumnVisibility = () => useContext(ColumnVisibilityContext)

export {ColumnVisibilityProvider, useColumnVisibility}
